import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const schoolResourceDetailsApi = createAsyncThunk(
    'auth/schoolResources/detail',
    async (id, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(apiRoutes.schoolProcessAction(`${id}`, 1))
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)
const intialState = { result: [], loading: false, error: null, message: "" }
const schoolResourceDetailsSlice = createSlice({
    name: 'schoolResource detail',
    initialState: { result: [], loading: false, error: null, message: "" },
    reducers: {
        resetschoolResource: () => intialState,
    },
    extraReducers: (builder) => {
        builder.addCase(schoolResourceDetailsApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(schoolResourceDetailsApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(schoolResourceDetailsApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})
export const { resetschoolResource } = schoolResourceDetailsSlice.actions;
export const schoolResourceDetailsReducer = schoolResourceDetailsSlice.reducer